import React from "react";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Cookiebanner from "./cookiebanner";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";

function Footer() {
  const [mcshow, setmcShow] = useState(false);
  const [switchState, setSwitchState] = useState(true);
  const [isSwitchOn, setIsSwitchOn] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    //script.src = "https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/a7df1d20886e43a289ada49553d1e90c706755774a814bb28a800a4fff2f87c9.js";
    script.async = true;
    script.defer = true;
    script.append(
      window.addEventListener(
        "load",
        () =>
          !(function (e, t, a) {
            window.ccChatbotId = e;
            window.ccChannelId = t;
            window.ccChannelToken = a;
            let c = document.getElementsByTagName("body")[0];
            let n = document.createElement("div");
            n.id = "web-widget";
            c.append(n);
            let d = document.getElementsByTagName("head")[0];
            let i = document.createElement("link");
            i.rel = "stylesheet";
            i.type = "text/css";
            i.href = "https://api.chatcaptain.com/widget/src/index.css";
            d.appendChild(i);
            let l = document.createElement("script");
            l.type = "module";
            l.src = "https://api.chatcaptain.com/widget/src/index.js";
            d.appendChild(l);
          })(
            "0QAZYD3l6kMKUhhZ1PSU",
            "V1iz6SoJRHOqJeQr7I5v",
            "ba2d4801057a2f5bddb0151d1541875bd655227d2a438cd2abbced199eba1c4d",
          ),
      ),
    );

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const onSwitchAction = () => {
    if (localStorage.getItem("Performance_cookie") === "false") {
      setIsSwitchOn(true);
    } else setIsSwitchOn(false);
  };

  const handleSave = () => {
    localStorage.setItem("Performance_cookie", isSwitchOn);
    setSwitchState(true);
    setmcShow(false);
  };

  const handleClose = () => setmcShow(false);

  const GoToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  return (
    <>
      <Modal
        show={mcshow}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="managecookies-custom-modal-styling-title">
            <img
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Hertz_247_logo.png"
              className="img-fluid"
              alt="Hertz24x7"
              width={200}
            />{" "}
            &nbsp; Meine Cookies verwalten
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Wenn Sie eine Website besuchen, kann sie Informationen in Ihrem
          Browser speichern oder abrufen, meist in Form von Cookies. Diese
          Informationen können sich auf Sie, Ihre Präferenzen oder Ihr Gerät
          beziehen und werden meist dazu verwendet, dass die Website so
          funktioniert, wie Sie es erwarten. Die Informationen identifizieren
          Sie normalerweise nicht direkt, aber sie können Ihnen ein
          personalisierteres Web-Erlebnis bieten. Zum Schutz Ihrer
          personenbezogenen Daten können Sie festlegen, bestimmte Arten von
          Cookies nicht zuzulassen. Klicken Sie auf die verschiedenen
          Kategorien, um mehr darüber zu erfahren und unsere
          Standardeinstellungen zu ändern.
          <Form>
            <div
              className="accordion p-4"
              id="accordionMgCookie"
              style={{ overflow: "auto" }}
            >
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-mgc_echeading">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-mgc_eccollapse"
                    aria-expanded="false"
                    aria-controls="flush-mgc_eccollapse"
                  >
                    <b>
                      {" "}
                      <Form.Check
                        disabled
                        type="switch"
                        label="Essentiell"
                        id="disabled-custom-switch"
                        defaultChecked={switchState}
                      />
                    </b>
                  </button>
                </h2>

                <div
                  id="flush-mgc_eccollapse"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-mgc_echeading"
                  data-bs-parent="#accordionMgCookie"
                >
                  <div className="accordion-body">
                    Einige Cookies sind für den Betrieb unserer Websites
                    unerlässlich. Ohne sie könnten Sie sich nicht auf der
                    Website bewegen und einige ihrer Funktionen nicht nutzen.
                    Notwendige Cookies ermöglichen, dass die von Ihnen
                    bereitgestellten Informationen und Ihre Entscheidungen
                    bezüglich Ihrer Anmietung im Buchungsprozess von Seite zu
                    Seite gespeichert werden. Da diese Cookies unerlässlich
                    sind, können Sie sie auf unserer Website nicht deaktivieren.
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Cookie</th>
                          <th>Beschreibung</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>dGroup</td>
                          <td>
                            Merkt sich, von welchem ​​Gerät aus auf die Site
                            zugegriffen wird (PC, Tablet, Telefon), um den
                            entsprechenden Inhalt anzuzeigen.
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>incap_ses_*</td>
                          <td>
                            Wird verwendet, um HTTP-Anfragen mit einer Sitzung
                            zu verknüpfen.
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>nlbi_*</td>
                          <td>
                            Dieses Cookie dient zum Herausfiltern böswilliger
                            Anfragen. Die generierten Informationen können Sie
                            nicht als Einzelperson identifizieren.
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>visid_incap_*</td>
                          <td>
                            Wird verwendet, um zu überprüfen, ob der Benutzer
                            Cookies akzeptiert und kein Roboter ist.
                          </td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>DC-Cookie</td>
                          <td>
                            Wird verwendet, um Sie während Ihres gesamten
                            Besuchs zum richtigen Server weiterzuleiten.
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-mgc_pcheading">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-mgc_pccollapse"
                    aria-expanded="false"
                    aria-controls="flush-mgccollapse2"
                  >
                    <b>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        label="Leistungs-Cookies"
                        onChange={onSwitchAction}
                        defaultChecked={isSwitchOn}
                      />
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-mgc_pccollapse"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-mgc_pcheading"
                  data-bs-parent="#accordionMgCookie"
                >
                  Wir verwenden Performance-Cookies, um die Leistung der Website
                  zu überwachen und zu analysieren, wie unsere Besucher unsere
                  Websites nutzen. Auf diese Weise können wir ein qualitativ
                  hochwertiges Erlebnis bieten, indem wir auftretende Probleme
                  schnell identifizieren und beheben und unser Angebot anpassen.
                  Alle gesammelten Informationen werden aggregiert und sind
                  daher anonym und werden nur dazu verwendet, die Funktionsweise
                  unserer Website zu verbessern.
                  <div className="accordion-body">NA</div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" onClick={handleSave}>
            Änderungen Speichern
          </Button>
        </Modal.Footer>
      </Modal>
      <Cookiebanner isVisible={localStorage.getItem("Cookie_acceptordeny")} />
      <div className="container-fluid p-4 body-font">
        <div className="row" style={{ backgroundColor: "lightgray" }}>
          <div
            className="col-xs-12 col-md-5 py-md-5"
            style={{ textAlign: "left" }}
          >
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Hertz-247-Horizontal-CMYK 1.png"
              alt=""
            />
            <p>
              Looking for hourly van rentals at a location near you? <br />{" "}
              Hertz 24/7® offers hourly van rentals, 24 hours a day, 7 days a
              week.
            </p>
          </div>
          <div className="col-xs-12 col-md-7 py-md-5">
            <div className="row">
              <div className="col-xs-12 col-md-4 ">
                <p>
                  <b>Über Hertz 24/7® </b>
                </p>
                <p>
                  <NavLink
                    className="nav-link"
                    to="/uk/ch/Howitworks"
                    onClick={GoToTop}
                  >
                    How it works
                  </NavLink>
                </p>
                <p>
                  <NavLink
                    className="nav-link"
                    to="/uk/ch/Locations"
                    onClick={GoToTop}
                  >
                    Locations
                  </NavLink>
                </p>
                <p>
                  <NavLink
                    className="nav-link"
                    to="/uk/ch/BusinessSolution"
                    onClick={GoToTop}
                  >
                    Business solutions
                  </NavLink>
                </p>
                <p>
                  <a
                    className="nav-link"
                    href="https://www.hertz.de/rentacar/misc/simpleIndex.jsp?targetPage=Impressum.xml"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Legal notice
                  </a>
                </p>
              </div>
              <div className="col-xs-12 col-md-4 ">
                <p>
                  <b>Help</b>
                </p>
                <p>
                  <NavLink className="nav-link" to="/uk/ch/FAQ" onClick={GoToTop}>
                    FAQ
                  </NavLink>
                </p>
                <p>
                  <NavLink className="nav-link" to="mailto:hertz247@hertz.ch">
                    Contact
                  </NavLink>
                </p>
              </div>
              <div className="col-xs-12 col-md-4 ">
                <p>
                  <b>More</b>
                </p>
                <p>
                  <a
                    className="nav-link"
                    href="https://www.hertz.ch/rentacar/misc/index.jsp?targetPage=CH_terms_of_use.jsp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms of use
                  </a>
                </p>
                <p>
                  <NavLink
                    className="nav-link"
                    onClick={() => {
                      setmcShow(true);
                      if (
                        localStorage
                          .getItem("Performance_cookie")
                          .toString() === "false"
                      )
                        setIsSwitchOn(false);
                      else setIsSwitchOn(true);
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    Manage my cookies
                  </NavLink>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ backgroundColor: "lightgray" }}>
          <span className="border border-2"></span>
          <div
            className="col-xs-12 col-md-1"
            style={{ textAlign: "center" }}
          ></div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "left" }}>
            <b>©2024 Hertz 24/7®. All rights reserved</b>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <div className="row">
              <div className="col-xs-12 col-md-4">
                <a href="https://apps.apple.com/de/app/hertz-24-7-mobility/id6453605078">
                  <img
                    className="img-fluid"
                    src="https://images.hertz.com/content/dam/hod/images/en-gb/static/AppleAppStore.png"
                    alt=""
                    width={250}
                  />
                </a>
              </div>
              <div className="col-xs-12 col-md-1">&nbsp;</div>
              <div className="col-xs-12 col-md-4">
                <a href="https://play.google.com/store/apps/details?id=com.hertz247.driverApp&hl=de_de&gl=de">
                  <img
                    className="img-fluid"
                    src="https://images.hertz.com/content/dam/hod/images/en-gb/static/GooglePlayStore.png"
                    alt=""
                    width={250}
                  />
                </a>
              </div>
              <div className="col-xs-12 col-md-3">
                <img
                  className="img-fluid"
                  src="https://images.hertz.com/content/dam/hod/images/en-gb/static/QR_Small.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <b>
                  <NavLink
                    className="nav-link"
                    to="https://www.hertz.de/rentacar/privacypolicy/index.jsp?targetPage=privacyPolicyView.jsp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy policy
                  </NavLink>
                </b>
              </div>
              <div className="col-xs-12 col-md-6">
                <b>
                  <NavLink
                    className="nav-link"
                    to="https://resources.hertz247.ufofleet.com/publishing/documents/247TCDEDE052024.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms and conditions
                  </NavLink>
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Footer;
